<script setup>
import {useStore} from 'vuex'

const store = useStore()
// const search = ref('')
// search.value=route.query.Search


import {computed} from 'vue'


const cartItems = computed(() => store.getters['cart/cartItems'])
const totalPrice = computed(() => store.getters['cart/cartTotal'])
const cartCount = computed(() => store.getters['cart/cartCount'])
</script>

<template>
  <div class="row">
    <div class="col-3">
      <h2>سبد خرید</h2>
<!--      <ul>
        <li v-for="item in cartItems" :key="item.id" class="border">
          <img class="card-img-top" :src="`/img/${item.img}`" :alt="item.name" width="200" height="200">
          {{ item.name }} -{{ item.price }} - ({{ item.quantity }} عدد)
        </li>
      </ul>-->
      <hr>
      <p>تعداد کل: {{ cartCount }} عدد</p>

      <p>جمع کل: {{ totalPrice }} تومان</p>
    </div>
  </div>


  <div class="row">
    <div class="col-10">
      <div v-for="item in cartItems" :key="item.id" class="row border-bottom p-lg-3">
        <div class="col-3 p-0"><img :src="`/img/${item.img}`" alt="aaa" class="" width="100%" height="150">
        </div>
        <div class="col-9 py-4">
          <p class="float-right">
            <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M5.46467 0.204501C4.88065 0.505601 4.62878 0.88917 4.52732 1.63155L4.44544 2.23092L2.65936 2.23107C1.11043 2.23114 0.838304 2.2484 0.609277 2.36121C-0.203092 2.76113 -0.203092 3.93162 0.609277 4.33155C0.855454 4.45277 1.39038 4.46162 8.5 4.46162C15.6096 4.46162 16.1445 4.45277 16.3907 4.33155C17.2031 3.93162 17.2031 2.76113 16.3907 2.36121C16.1617 2.2484 15.8896 2.23114 14.3406 2.23107L12.5546 2.23092L12.4727 1.63155C12.3712 0.88917 12.1193 0.505601 11.5353 0.204501L11.1387 0H8.5H5.86126L5.46467 0.204501ZM11.1417 1.26709C11.2734 1.38733 11.3078 1.50282 11.3078 1.82482V2.23092H8.5H5.69218V1.82482C5.69218 1.50282 5.72656 1.38733 5.8583 1.26709C6.01834 1.12089 6.11351 1.11546 8.5 1.11546C10.8865 1.11546 10.9817 1.12089 11.1417 1.26709ZM1.17775 6.00489C1.20324 6.24003 1.44039 9.00295 1.70478 12.1447L2.18552 17.8568L2.40415 18.2033C2.53574 18.4119 2.77069 18.6395 2.99425 18.775L3.36572 19H8.5H13.6343L14.0057 18.775C14.2293 18.6395 14.4643 18.4119 14.5958 18.2033L14.8145 17.8568L15.2952 12.1447C15.5596 9.00295 15.7968 6.24003 15.8223 6.00489L15.8685 5.5773H8.5H1.13146L1.17775 6.00489ZM5.45906 6.83613C5.5395 6.91496 5.62419 7.12414 5.64711 7.30091C5.6701 7.47767 5.81178 9.59035 5.96189 11.9957C6.21315 16.0211 6.22529 16.3834 6.11434 16.5493C5.88463 16.8927 5.32178 16.8585 5.16082 16.4913C5.08858 16.3265 4.55388 8.36803 4.55388 7.45759C4.55388 7.07849 4.58355 6.96887 4.72 6.84439C4.92929 6.65335 5.26866 6.64955 5.45906 6.83613ZM8.86509 6.84439L9.03121 6.99602V11.7495V16.503L8.86509 16.6546C8.7738 16.738 8.6095 16.8063 8.5 16.8063C8.39049 16.8063 8.2262 16.738 8.13491 16.6546L7.96879 16.503V11.7495V6.99602L8.13491 6.84439C8.2262 6.76103 8.39049 6.69276 8.5 6.69276C8.6095 6.69276 8.7738 6.76103 8.86509 6.84439ZM12.28 6.84439C12.5012 7.04629 12.501 7.05841 12.1749 12.1568C11.9702 15.3579 11.877 16.438 11.7946 16.5634C11.5768 16.8945 11.015 16.851 10.8472 16.4899C10.79 16.367 10.8504 15.0372 11.0654 11.6789L11.3625 7.03758L11.567 6.86521C11.8194 6.65253 12.0621 6.64546 12.28 6.84439Z"
                    fill="#FF5775"></path>
            </svg>
          </p>
          <p class="col-12">{{ item.name }}</p></div>
        <div class="col-12 float-right">
          <div class="row mb-3">
            <div class="col-12 col-lg-auto my-3 my-lg-0 offset-lg-3">
              <button class="btn text-white small" style="font-size:12px;background-color:#57a4ff;border-radius:59px"
                      data-toggle="modal" data-target="#exampleModal">مشاهده بیشتر
              </button>
            </div>
            <div class="col text-right py-3 px-0"><s class="text-muted">1,800,000</s> <span><span
                style="font-size:20px;border-right:2px solid #cbcbcb;padding:0 10px">{{ item.price }}</span> <span class="small">تومان</span></span>
              <div class="input-wrapper ml-2">
                <button id="increment" class="increment">+</button>
                <input type="number" id="quantity" min="1" max="10" value="1" readonly="readonly">
                <button id="decrement" class="decrement">-</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-2">
      AAAAAAAAA
    </div>
  </div>




</template>

<style scoped>

</style>